
<template>
    <div class="container-promocao">
      <div   v-if="isActive">
        <b-col><p class ="menssagem-promo-titulo">{{ title }}</p>
        <p class ="menssagem-promo-titulo-dois"></p>
        <p class ="menssagem-promo-subtitulo">Faça uma cotação e esteja protegido contra:</p>
        <Icons icon="icon" iconV="icon-v" :iconvOrx="false"/>
        </b-col>
      </div>

      <div  v-if="!isActive" id="acaoDefault">
       <div class="home">
           <p class="novo">Novo</p>
              <p class="celular-protegid">Proteja seu dispositivo</p>
              <p class="celular-protegidSM">Seguro <br />{{ product }}</p>
              <br />
        </div>
      </div>
    </div>
</template>
<script>
import './AcaoPromocao.css'
import Icons from '@/components/Icons/Icons'

export default {
  name: 'AcaoPromocao',
  props: {
    isActive: {
      type: Boolean,
      required: true
    }
  },
  components: {
    Icons
  },
  computed: {
    title: function () {
      return process.env.VUE_APP_PRODUCT_NAME === 'seguro-equipamentos-portateis'
        ? 'Proteja seu dispositivo'
        : 'Seguro celular'
    },
    product () {
      return process.env.VUE_APP_PRODUCT_NAME === 'seguro-equipamentos-portateis'
        ? 'Equipamentos Portáteis'
        : 'celular'
    }
  }
}
</script>
